import React, { useState } from 'react';
import { SelectPicker } from 'rsuite';
import styles from './SelectPeriod.module.scss';
import { selectPeriodData } from '../../data';

type SelectPeriodProps = {
  onChange: (value: number) => void;
};

export const SelectPeriod = ({ onChange }: SelectPeriodProps) => {
  const [selectValue, setSelectValue] = useState(90);

  const handleChange = (value: number) => {
    setSelectValue(value);
    onChange(value);
  };

  return (
    <SelectPicker
      id="select-period-picker"
      className={styles['select-period-picker']}
      placement="bottomEnd"
      data={selectPeriodData}
      value={selectValue}
      cleanable={false}
      searchable={false}
      onChange={handleChange}
    />
  );
};
